<template>
  <div style="padding:20px;">
    <el-row :gutter="24">
      <el-row style="margin-bottom: 10px;">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>&nbsp;&nbsp;
        奖品：
        <el-input class="search-el" v-model="query.id_title" size="small" placeholder="福袋奖品名称/福袋ID" clearable></el-input>
        类型：
        <el-select class="search-el" clearable size="small" v-model="query.type" placeholder="选择类型">
          <el-option label="全部" value=""></el-option>
          <el-option label="实物奖品" value="2"></el-option>
          <el-option label="体验营" value="1"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="query.page=1; getList()">搜索</el-button>
        <el-button type="primary" size="small" @click="toWinnerList()">中奖名单</el-button>
        <el-button type="primary" size="small" @click="toInfo('create', 0)">发起福袋</el-button>
        <el-button type="primary" size="small" @click="refresh()">刷新</el-button>
      </el-row>
      <el-row style="margin-bottom: 10px;">
        客服微信：
        <el-input class="search-el" v-model="wechat" size="small" placeholder="" clearable :disabled="wechatDisabled"></el-input>
        <template v-if="wechatDisabled">
          <el-button type="primary" size="small" @click="wechatDisabled=false" :loading="wechatLoading">修改</el-button>
        </template>
        <template v-else>
          <el-button type="primary" size="small" @click="modifyBlessingBagWechat()" :loading="wechatLoading">保存</el-button>
          <el-button size="small" @click="wechatDisabled=true; wechat = sourceWechat;">取消</el-button>
        </template>
      </el-row>
      <el-table :data="listData" style="width: 100%" border v-loading="listLoading">
        <el-table-column prop="id" label="ID" width="90"></el-table-column>
        <el-table-column label="奖品类型">
          <template slot-scope="{row}">
            <template v-if="row.type == 1">体验营</template>
            <template v-else>实物奖品</template>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="奖品名称"></el-table-column>
        <el-table-column prop="lottery_num" label="中奖名额（人）"></el-table-column>
        <el-table-column prop="join_num" label="实际参与人数"></el-table-column>
        <el-table-column prop="virtual_number" label="虚拟参与人数"></el-table-column>
        <el-table-column label="福袋时长">
          <template slot-scope="{row}">
            {{ (row.lottery_duration / 60) + '分钟' }}
          </template>
        </el-table-column>
        <el-table-column label="开奖时间">
          <template slot-scope="{row}">
            {{ row.real_send_at_lottery_duration }}
          </template>
        </el-table-column>
        <el-table-column label="参与方式">
          <template slot-scope="{row}">
            评论“{{ row.join_way_content }}”
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="{row}">
            <template v-if="row.status == 0">下架</template>
            <template v-else-if="row.status == 1">待发布</template>
            <template v-else-if="row.status == 2">排队中</template><!--排队中-->
            <template v-else-if="row.status == 3">进行中</template><!--进行中-->
            <template v-else-if="row.status == 4">已开奖</template>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <template v-if="row.status == 1">
              <el-button type="primary" size="small" @click="toInfo('edit', row.id)">编辑</el-button>
              <el-button type="primary" size="small" @click="sendBlessingBag(row.id)">发布</el-button>
            </template>
            <template v-else>
              <el-button type="primary" size="small" @click="toInfo('copy', row.id)">再次发起</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top:10px">
        <el-pagination background @current-change="getList" :current-page.sync="query.page" :page-size="query.limit" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getBlessingBagList, getBlessingBagWechat, modifyBlessingBagWechat, sendBlessingBag } from '@/api/live'

export default {
  data: function () {
    return {
      course_id: this.$route.query.course_id,
      period_id: this.$route.query.period_id,
      listData: [],
      listLoading: false,
      total: 0,
      wechatDisabled: true,
      wechat: '',
      sourceWechat: '',
      wechatLoading: false,
      query: {
        course_id: this.$route.query.course_id,
        period_id: this.$route.query.period_id,
        limit: 10,
        page: 1,
        id_title: '',
        type: '',
      },
    }
  },
  created: function () {
    this.getList()
    this.getBlessingBagWechat()
  },
  methods: {
    wechatCancel() {
      this.wechatDisabled=true;
      this.wechat = this.sourceWechat;
    },
    refresh() {
      this.query.page = 1
      this.query.id_title = ''
      this.query.type = ''
      this.getList()
    },
    modifyBlessingBagWechat() {
      this.wechatLoading = true
      modifyBlessingBagWechat({
        course_id: this.$route.query.course_id,
        period_id: this.$route.query.period_id,
        wechat: this.wechat,
      }).then((response) => {
        this.wechatLoading = false
        this.wechatDisabled = true
        this.sourceWechat = this.wechat
      })
    },
    sendBlessingBag(id) {
      this.sendLoading = true
      sendBlessingBag({id}).then((response) => {
        this.sendLoading = false
        this.refresh()
      })
    },
    getList() {
      this.listLoading = true
      getBlessingBagList(this.query).then((response) => {
        this.listData = response.data.list
        this.total = response.data.total;
        this.listLoading = false
      })
    },
    getBlessingBagWechat() {
      this.wechatLoading = true
      getBlessingBagWechat({
        course_id: this.$route.query.course_id,
        period_id: this.$route.query.period_id,
      }).then((response) => {
        this.wechat = this.sourceWechat = response.data.wechat
        this.wechatLoading = false
      })
    },
    toInfo(action, id) {
      this.$router.push({
        path: '/live/blessingBag/info',
        query: {
          course_id: this.course_id,
          period_id: this.period_id,
          id: id,
          action: action,
        },
      })
    },
    toWinnerList() {
      this.$router.push({
        path: '/live/blessingBag/winnerList',
        query: {
          course_id: this.course_id,
          period_id: this.period_id,
        },
      })
    },
  },
}
</script>

<style>
</style>